import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import VeryconVariants2 from "../../Assets/products_landing/VeryconCompact_Output_Configuration.svg"
import VeryconVariants2Left from "../../Assets/products_landing/VeryconCompact_highlights_v2.svg"
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import FormModal from "../ProductsLanding/FormModal";

const VeryconCompact = () => {
    const navigate = useNavigate();
    const [productTitle, setProductTitle] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {

        setIsModalOpen(true)
    };
    return (        
        <section className="bg-light-gradient">
            <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0 containers-min mx-auto">
                <h3 className="text-center font-gilroy">
                    AC Charger Controller – Verycon Compact
                </h3>
                <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                    Develop OCPP-compliant AC EV chargers (Single Gun) upto 7.5 kW with the Verycon Compact Controller, optimized for commercial and residential EV charging stations. Built-in energy metering, on-board relay, and smart connectivity reduce design complexity and accelerate time-to-market for EV charger manufacturers.
                </p>
            </div>            
            <div className="flex xLg:flex-row flex-col-reverse gap-3 relative gap-y-6">
                <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center flex-col lg:justify-end px-3 pl-5 lg:pl-20 xl:pl-10">
                    <h5 className="font-semibold font-gilroy">AC Charger Output Configuration</h5>
                    <img src={VeryconVariants2} alt="VeryconVariants2" />
                    <div className="flex items-center py-2 sm:py-3 gap-3 w-full sm:w-2/3">
                        <div onClick={() => {
                            openModal()
                            setProductTitle("AC Charger Controller - Verycon Compact")
                        }}>
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Get Quote
                            </button>
                            {/* <Button title="Contact Us" /> */}
                        </div>

                        <div className='group cursor-pointer'>
                            <a href="https://resources.verdemobility.com/files/VeryconCompact_V3.pdf" target="_blank" className='text-gray-600'>
                                <button
                                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                >
                                    <span className="flex justify-center items-center">
                                        <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                        <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                    </span>
                                    Brochure
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className=" flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px] px-4">
                    {/* Gradient Overlay */}
                    <div className="absolute inset-y-0 right-0 w-24 sm:w-32 md:w-56 lg:w-80 bg-gradient pointer-events-none"></div>

                    {/* Image Container */}
                    <div className="relative z-10 w-full max-w-[90vw] md:max-w-[85vw] lg:max-w-[80vw] xl:max-w-[75vw] 2xl:max-w-[1200px] bg-grey rounded-3xl overflow-hidden px-4 py-4 xLg:mr-[205px]">
                        <img
                            loading="lazy"
                            src={VeryconVariants2Left}
                            alt="Verycon 2.0"
                            className="w-full h-auto max-h-[90vh] object-contain"
                        />
                    </div>
                </div>

            </div>
            {isModalOpen && <FormModal isModalOpen={isModalOpen} productTitle={productTitle} setIsModalOpen={setIsModalOpen} />}
        </section>
    );
};

export default VeryconCompact;
